import { actionsRequest, handleRequestError } from '@/api/utils'
import { Action, ACTION_TYPE } from '@/types/action'
import { ERROR_CODE } from '@/types/error'

export const resetTraces = async <T extends Action<ACTION_TYPE.RESET_TRACES>>(payload: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload,
      type: ACTION_TYPE.RESET_TRACES
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.RESET_TRACES, payload)
    throw err
  }
}
